module.exports = new __parcel__URL__("crash_6.9dcf9ed6.mp3").toString();